import React, { useState, useEffect } from 'react';
import DatabaseSubTable from '../SubTables';

const TeamSeasonsRow = ({ teamId, season, index }) => (
    <>
        {season.map((driverData, entryIndex) => {
            const key = `${index}_${entryIndex}`;
            const seasonDataCount = season.length;
            const props = { key, index, entryIndex, driverData, seasonDataCount };

            return <TeamSeasonsDriverRow {...props} />;
        })}
    </>
);

const TeamSeasonsDriverRow = ({ index, entryIndex, driverData, seasonDataCount }) => {
    const [nestedTable, setNestedTable] = useState(null);
    const [nestedTableToggled, setNestedTableToggled] = useState(false);
    const teamFailuresToStart = driverData.num_races_fails > 0 ? ` (${driverData.num_races_fails})` : '';
    const teamStarts = `${driverData.num_races}${teamFailuresToStart}`;

    const onClick = (championshipId, driverId, teamId) => {
        setNestedTableToggled(!nestedTableToggled);

        if (nestedTable !== null) {
            return;
        }

        setNestedTable(<DatabaseSubTable type="team" driver={driverId} team={teamId} championship={championshipId} />);
    };

    const rowCssClasses = (index, entryIndex) => {
        let rowCssClasses = 'database-table__row';

        if (index % 2 !== 0) {
            rowCssClasses += ' database-table__row--grey';
        }

        if (nestedTableToggled) {
            rowCssClasses += ' open';
        }

        if (entryIndex + 1 < seasonDataCount) {
            rowCssClasses += ' database-table__tr--no-line';
        }

        return rowCssClasses;
    };

    return (
        <>
            <tr className={rowCssClasses(index, entryIndex)}>
                <td>
                    {entryIndex === 0 && (seasonDataCount === 1 || entryIndex + 1 < seasonDataCount) && (
                        <p className="database-table__title">
                            <a href={driverData.championship_url}>{driverData.championship}</a>
                        </p>
                    )}
                </td>
                <td>
                    <p className="database-table__title">
                        <a href={driverData.driver_url}>{driverData.driver}</a>
                    </p>
                </td>
                <td className="u-hidden-mobile">
                    <p className="database-table__subtitle database-table__subtitle--black proxima">
                        {teamStarts}
                    </p>
                </td>
                <td className="u-hidden-mobile">
                    {entryIndex === 0 && (seasonDataCount === 1 || entryIndex + 1 < seasonDataCount) && (
                        <p className="database-table__title">
                            <a href={driverData.team_url}>
                                {driverData.team_entrant !== '' ? driverData.team_entrant : driverData.team}
                            </a>
                        </p>
                    )}
                </td>
                <td>
                    {entryIndex === 0 && (seasonDataCount === 1 || entryIndex + 1 < seasonDataCount) && (
                        <p
                            className="database-table__subtitle database-table__subtitle--black proxima"
                            dangerouslySetInnerHTML={{ __html: driverData.position }}></p>
                    )}
                </td>
                <td>
                    <p
                        className="database-table__subtitle database-table__subtitle--black proxima"
                        dangerouslySetInnerHTML={{ __html: driverData.driver_position }}></p>
                </td>
                <td>
                    {driverData.nestedTable == true && (
                        <a
                            onClick={e => onClick(driverData.championship_id, driverData.driver_id, driverData.team_id)}
                            className="database-table__toggle"></a>
                    )}
                </td>
            </tr>
            <tr className={`${rowCssClasses()} database-table__hidden`}>{nestedTable}</tr>
        </>
    );
};

export default TeamSeasonsRow;
